<template>
  <div class="filters">
    <div class="filter-column-mobile bb-column bb-px-4" v-if="isMobile">
      <p class="figtree-font bb-semi-bold bb-mb-1">
        {{ resultDescriptionTitle }}
      </p>
      <div class="bb-row bb-justify-content-between bb-mb-2">
        <div class="form-container">
          <form
            method="GET"
            class="form bb-mr-5"
            @submit.prevent="setKeywordsAndFetch"
          >
            <div
              class="bb-control search-bar-container bb-row bb-justify-content-end"
            >
              <input
                type="search"
                autocomplete="off"
                name="keywords"
                aria-label="search-text"
                class="bb-input codeInput"
                placeholder="Buscar"
                v-model="keywordsModel"
                @input="event => setKeywordsAndFetch()"
              />
              <button
                type="submit"
                v-html="searchIcon"
                class="btn-search"
                ref="btnSearch"
                aria-label="search-button"
              ></button>
            </div>
          </form>
        </div>
        <filter-column-mobile
          :is-box-catalog="isBoxCatalog"
        ></filter-column-mobile>
      </div>
      <hr class="lightGrayRule" />
    </div>

    <div class="filter-column-desktop" v-else>
      <form
        method="GET"
        class="form bb-mx-1 bb-mt-2"
        @submit.prevent="setKeywordsAndFetch"
      >
        <div
          class="bb-control search-bar-container bb-row bb-justify-content-end"
        >
          <input
            type="search"
            autocomplete="off"
            name="keywords"
            aria-label="search-text"
            class="bb-input codeInput"
            placeholder="Buscar"
            v-model="keywordsModel"
            @input="event => setKeywordsAndFetch()"
          />
          <button
            type="submit"
            v-html="searchIcon"
            class="btn-search"
            ref="btnSearch"
            aria-label="search-button"
          ></button>
        </div>
      </form>
      <filter-column :is-box-catalog="isBoxCatalog"></filter-column>
    </div>

    <div class="option-cards-container" v-if="!isMobile">
      <div
        class="option-cards-filter bb-row bb-my-4 bb-mx-8 bb-px-2 bb-py-4"
        v-if="keywords"
      >
        <span
          >Resultados de busqueda: <b>"{{ keywords }}"</b></span
        >
        <span
          class="icon bb-cursor-pointer bb-mr-2"
          v-html="require('assets/icons/close_gray.svg')"
          @click="clearKeywords"
        ></span>
      </div>
    </div>

    <div class="filter-results">
      <div class="bb-column bb-mx-8 bb-mb-2 bb-hidden-md-min">
        <div class="--relative bb-column full-width">
          <span class="text figtree-font bb-bold bb-my-4">
            {{ resultDescriptionTitle }}
          </span>
          <div class="order-by-container">
            <order-by :is-box-catalog="isBoxCatalog" />
          </div>
        </div>
      </div>
      <search-result :is-box-catalog="isBoxCatalog" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';

  import SearchResult from 'components/DynamicFilters/SearchResult/SearchResult.vue';
  import FilterColumn from 'components/DynamicFilters/FilterColumn/FilterColumn.vue';
  import FilterColumnMobile from 'components/DynamicFilters/FilterMobile/FilterMobile.vue';
  import OrderBy from 'components/DynamicFilters/OrderBy/OrderBy.vue';
  import SearchTags from 'components/DynamicFilters/SearchTags/SearchTags.vue';
  import SpinnerLoading from 'common/components/SpinnerLoading/SpinnerLoading.vue';
  import searchIcon from 'common/icons/Search.svg';

  import { Watch } from 'vue-property-decorator';

  import useCatalogFilters from 'composables/useCatalogFilters';
  import getLastTld from 'common/services/utils/getLastTld';

  @Component({
    components: {
      SearchResult,
      FilterColumn,
      FilterColumnMobile,
      OrderBy,
      SearchTags,
      SpinnerLoading,
    },
    setup() {
      const {
        getFacets,
        getCurrentFilters,
        getCurrentTags,
        getCardSelected,
        getResults,
        getLoading,
        getPageInfo,
        setKeywords,
        getBoxes,
        getActivities,
        getTravel,
        getDataFromFilters,
        setCard,
        setBoxCategory,
        clearCurrentFilters,
        setBoxId,
      } = useCatalogFilters();
      return {
        facets: getFacets,
        currentFilters: getCurrentFilters,
        currentTags: getCurrentTags,
        cardSelected: getCardSelected,
        results: getResults,
        loading: getLoading,
        pageInfo: getPageInfo,
        getBoxes,
        setKeywords,
        getActivities,
        getTravel,
        getDataFromFilters,
        setCard,
        setBoxCategory,
        clearCurrentFilters,
        setBoxId,
      };
    },
  })
  export default class ExperienceFilter extends Vue {
    keywordsModel = '';

    searchIcon = searchIcon;

    get isBoxCatalog() {
      return Boolean(
        this.$route.name === 'box-catalog' || this.$route.name === 'box',
      );
    }

    get resultDescriptionTitle() {
      if (this.loading) return '';
      if (this.pageInfo.count === 1) {
        return 'Elegí esta experiencia:';
      } else if (this.pageInfo.count > 1) {
        return `Elegí una de estas ${this.pageInfo.count} experiencias:`;
      } else {
        return 'No hay experiencias disponibles.';
      }
    }

    /**
     * There are 3 possibly options:
     * 0: boxes
     * 1: activities
     * 2: travel activities (Only in available countries)
     * @param {Number} cardSelected
     * @returns {Boolean} if card selected value is right
     */
    validateCardSelected(cardSelected) {
      const countryCode = getLastTld();
      const validOptions = [0, 1];
      // if (TravelActivitiesAvailableCountries.includes(countryCode)) {
      //   validOptions.push(2);
      // }
      return validOptions.includes(cardSelected);
    }

    async clearKeywords() {
      this.$router.replace({
        name: 'products',
        query: { ...this.$route.query, keywords: '' },
      });
    }

    get isMobile() {
      return this.$screen.width < 991;
    }

    get keywords() {
      return this.$route.query.keywords;
    }

    async setKeywordsAndFetch() {
      setTimeout(() => {
        this.setKeywords(this.keywordsModel || '');
      }, 500);
    }

    @Watch('$route.query.keywords', { immediate: true })
    onChangeKeywords() {
      this.setKeywordsAndFetch();
    }

    @Watch('$route.query.filters')
    // At the moment we don't have the feature of manage filters via url, so momentarily i manage only allGiftsMenu category filters via url because it's how it should be
    // So when we reset filters in the store we check if exists route query filters and remove them
    onRouteCategoryChange(val) {
      if (!val) return;
      const parsedVal = JSON.parse(val);
      if (parsedVal.boxCategory) {
        this.setBoxCategory(parsedVal.boxCategory);
      } else {
        this.clearCurrentFilters();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';

  .filters {
    position: relative;
    display: grid;
    background-color: #fafafa;
    grid-template-areas:
      'filter-column option-cards'
      'filter-column filter-results';
    grid-template-columns: 220px auto;
    grid-template-rows: auto 1fr;
    padding: 16px;
    column-gap: 30px;

    @media screen and (max-width: 1700px) {
      padding: 0 0;
      // padding-top: 16px;
    }

    @media screen and (max-width: 1400px) {
      padding: 0 0;
      // padding-top: 16px;
    }

    @media screen and (max-width: $screen-md) {
      gap: 0;
      padding: 0;
      grid-template-rows: 110px auto;
      grid-template-columns: auto;
      grid-template-areas:
        'filter-column-mobile'
        'filter-results';
    }

    @media screen and (max-width: $screen-sm) {
      grid-template-rows: 100px auto;
    }

    .option-cards-continaer {
      position: relative;
      display: flex;
      flex-direction: column;
    }

    .option-cards-filter {
      position: relative;
      display: flex;
      justify-content: space-between;
      border-radius: 10px;
      border: 1px solid #f2f2f2;
      background-color: white;

      .icon {
        svg {
          width: 12px;
        }
      }
    }
  }

  .form-container {
    flex-grow: 1;
    max-width: min(65%, 300px);
  }

  .form {
    display: inline-flex;
    position: relative;

    gap: 16px;

    @media (max-width: $screen-sm-max) {
      flex-direction: row-reverse;
      margin-right: 0;
      margin-left: auto;
      width: 100%;
      padding-right: 0px;
    }

    .search-bar-container {
      width: 220px;
      height: 40px;

      @media (max-width: $screen-sm-max) {
        width: 100%;
      }

      @media (max-width: $screen-md-min) {
        border-radius: 50%;

        .search-input {
          display: none;
        }

        .btn-search {
          width: 16px;
          height: 16px;
          position: relative;
          margin-top: 3px;

          &:deep(svg) {
            height: 16px;
            width: 16px;
          }
        }
      }

      input {
        height: 40px;
        width: 550px;
        border-radius: 10px;
        border-color: $GRAY-LIGHT;
        font-size: 14px;
        min-height: 0;
        padding: 11px 55px 11px 15px;
        transition: width 0.3s;
        color: #222222;

        @media (max-width: $screen-md-max) {
          width: 400px;
        }

        @media (max-width: $screen-sm-max) {
          width: 100%;
        }

        @media (max-width: $screen-xs-min) {
          padding: 0 $MINI;
          &:focus {
            border-color: $PRIMARY;
          }
        }

        &::placeholder {
          color: $MID-GRAY;
        }
      }

      .btn-search {
        width: 32px;
        height: 100%;
        background-color: transparent;
        border: none;
        position: absolute;
        top: 0px;
        right: 16px;
        display: flex;
        align-items: center;

        animation-duration: 4s;
        animation-delay: 2s;
        animation-direction: alternate;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

        &:hover {
          cursor: pointer;
        }

        &:deep(svg) {
          height: 18px;
          color: $PRIMARY;
        }

        @media (max-width: $screen-md-min) {
          padding: $MINI;
        }
      }
    }
  }

  .filter-column-desktop {
    grid-area: filter-column;
  }

  .filter-column-mobile {
    grid-area: filter-column-mobile;
  }

  .filter-results {
    grid-area: filter-results;
    overflow-x: hidden;
    position: relative;

    .text {
      font-size: 20px;
      line-height: 22px;
      color: #464646;

      &.--quiz {
        font-family: 'Figtree', sans-serif;
        font-size: 18px;
      }
    }

    .--relative {
      position: relative;

      .order-by-container {
        position: absolute;
        bottom: 15px;
        right: 0;
      }
    }

    .filter-results-container {
      position: relative;
    }
  }
</style>
